import React from 'react';
export function IntegrationIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 1v22H1V1h22zm-6 2v7h-3.732l-.284-.25a3 3 0 100 4.5l.284-.25H17v7h4V3h-4zm-2 18v-5h-1a5 5 0 110-8h1V3H3v18h12z"
  }));
}